import { doRequest } from '../../api/index';
import store from '../index';

const state = {
  menuPages: [],
  pages: {},
  details: {},
};

const getters = {
  getMenuPages(s) {
    return s.menuPages;
  },
  pages(s) {
    return s.pages;
  }
};

const actions = {
  loadPages({ commit }, args) {
    if (Object.keys(store.state.pages.menuPages).length === 0) {
      return doRequest('pages.list', args)
        .then((data) => {
          commit('setMenuPages', data);
          return data;
        });
    }

    return Promise.resolve();
  },
  loadPage({ commit }, args) {
    return doRequest('pages.page', args)
      .then((data) => {
        commit('setPage', {
          data,
          slug: args.slug
        });
        return data;
      });
  },
  createPage({ commit }, args) {
    return doRequest('pages.create', args)
      .then((data) => {
        commit('clearStoragePage');
        return data;
      });
  },
  editPage({ commit }, args) {
    return doRequest('pages.edit', args)
      .then((data) => {
        commit('clearStoragePage');
        return data;
      });
  },
  loadPageDetail({ commit }, args) {
    return doRequest('pages.detail', args)
      .then((data) => {
        commit('setPageDetail', {
          data,
          slug: args.slug
        });
        return data;
      });
  }
};

const mutations = {
  setMenuPages(s, data) {
    s.menuPages = data;
  },
  setPage(s, page) {
    s.pages = Object.assign({}, s.pages, {
      [page.slug]: page.data
    });
  },
  setPageDetail(s, page) {
    s.details = Object.assign({}, s.details, {
      [page.slug]: page.data
    });
  },
  clearStoragePage(s) {
    s.pages = {};
    s.menuPages = [];
    s.details = {};
  }
};


export default {
  state,
  getters,
  actions,
  mutations,
};
